import { render, staticRenderFns } from "./AddressBookTable.vue?vue&type=template&id=0d627aa6&scoped=true&"
import script from "./AddressBookTable.vue?vue&type=script&lang=js&"
export * from "./AddressBookTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d627aa6",
  null
  
)

export default component.exports